import policies from "../../views/modules/Development/policies";
import layouts from "../../layout";
import policiesCont from "../../views/modules/Development/policiesContent";

export default {
  path: "/policies",
  name: "policies",
  component: policies,
  meta: {
    auth: true
  },
  redirect: {
    name: "development-policies"
  },
  children: [
    {
      path: "documents",
      name: "development-policies",
      component: policiesCont,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Policies",
        tags: ["policies", "documents"],
        index: true
      }
    }
  ]
};
